import { render, staticRenderFns } from "./HoldingAnalysisFeedback.vue?vue&type=template&id=75ea6a86&scoped=true&"
import script from "./HoldingAnalysisFeedback.vue?vue&type=script&lang=js&"
export * from "./HoldingAnalysisFeedback.vue?vue&type=script&lang=js&"
import style0 from "./HoldingAnalysisFeedback.vue?vue&type=style&index=0&id=75ea6a86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ea6a86",
  null
  
)

export default component.exports